import React from 'react'
import AdvantCard from '../UI/advantagesCard'
import * as styles from './advantages.module.css'

const Advantages = () => {
  const data = [
    {
      title: 'Дизайн специально для Вас',
      body: 'Мы считаем, что творчество имеет решающее значение для любого успешного веб-сайта. Вот мы почему мы всегда стремимся разработать уникальное оформление для каждого клиента.',
      svg: 1,
    },
    {
      title: 'Веб-сайты для бизнеса',
      body: 'Цель любого бизнеса - прибыль. Наша цель - помочь Вам с этим. Мы проводим глубокий анализ Вашей ниши и создаем конкурентные сайты, помогающие Вам в достижении цели.',
      svg: 2,
    },
    {
      title: 'Бесконечные возоможности',
      body: 'Мы создаем веб-сайты любой сложности - от посадочных старниц до онлайн магазинов. Вы получаете полностью функциональный веб-сайт, отвечающий всем Вашим требованиям.',
      svg: 3,
    },
  ]
  return (
    <section>
      <div className={styles.advantages} id="about">
        <span>Возможности</span>

        <h2>Решения, которые работают для Вас и Вашего успеха</h2>
        <span className={styles.advantagesDesc}>
          Работая с нами, Вы получите больше, чем просто красивый сайт. Для
          каждого проекта мы подбираем уникальные решения, исходя из
          потребностей клиента.
        </span>
        <div className={styles.cardContainer}>
          {data.map((el) => {
            return (
              <AdvantCard className={styles.item} data={el} key={el.title} />
            )
          })}
          {/* <AdvantCard className={styles.item} svg={1} />
          <AdvantCard className={styles.item} svg={2} />
          <AdvantCard className={styles.item} svg={3} /> */}
        </div>
      </div>
    </section>
  )
}

export default Advantages
